import { ISceneData } from "./interfaces/ISceneData";

export const SCENE_DATA: ISceneData = {
  boothURL: null,
  boothSmallURL: null,
  warehouseURL: null,
  booths: null,
};
